export const roles = [
  {
    label: 'Product Designer',
    value: 'product_designer',
  },
  {
    label: 'Software Engineer',
    value: 'software_engineer',
  },
];
export const countries = [
  {
    label: 'United States',
    value: 'usa',
  },
  {
    label: 'Bangladesh',
    value: 'bd',
  },
];
export const timezones = [
  {
    label: 'Pacific Standard Time (PST) UTC-08:00',
    value: 'pst',
  },
  {
    label: 'Bangladesh Standard Time (BST) UTC+06:00',
    value: 'bst',
  },
];
